module.exports = __webpack_public_path__ + "img/rewind.a24b96c8.svg";